import React from "react";
import { Button } from "react-bootstrap";
import { injectIntl } from "react-intl";
import { Link } from "react-router-dom";
// import Alert from "react-s-alert";
import confirmDelete from "../../components/ConfirmDelete";
import getEncodedImageUrl from "../../helpers/getEncodedImageUrl";
import ImgToolTip from '../ImgTooltip';
import { PreIcon, VidIcon } from '../svgs';
import TitleTooltip from '../TitleTooltip';


const AddedEvent = ({
  name,
  date,
  location,
  link,
  id,
  logo,
  deleteFn,
  intl,
  display,
  slug
}) => {
  
  let mode;

  switch (display) {
    case "password":
      mode = 'icon-mode-lock-dark.svg';
      break;
    case "public":
      mode = 'icon-mode-public-dark.svg';
      break
    case "login":
      mode = 'icon-mode-login-dark.svg';
      break
    default:
      mode = 'icon-mode-link-dark.svg';
      break;
  }

  console.log(slug, "this is the slug from index.jsx manager side to check the path next to REACT_APP_AUDIENCE_SITE_ROOT");
  
  return (
    <div className="added-event-container">
      <div className="e-name-container">
        <div className="e-name">
          <div className="event-icon-container">
            <img
              className="event-icon rounded-circle"
              src={
                logo
                  ? getEncodedImageUrl(logo, 85, 85)
                  : "/icons/added-event-icon.png"
              }
              alt=""
            />
            <span className="event-display">
              <img
                src={`/icons/states/${mode}`}
                alt="private"
              />
            </span>
            {/* <img className="event-display" src="/icons/public.png" alt="public" /> */}
          </div>
          <div className="m-l-45">
            {name.length > 69 ? <TitleTooltip title={name} placement="bottom" id={id} /> : <h6>{name}</h6> }
            {/* <h6>{name}</h6> */}
            <span>{date}</span>
          </div>
        </div>
        <div className="del-event-container">
          <Button
            onClick={() => {
              confirmDelete(intl, id, undefined, (_id) => {
                deleteFn(_id)
              }, intl.formatMessage({id: 'action.delete-event'}));
            }}
          >
            <ImgToolTip className="icon-normal" intl={intl} placement="left" tooltiptext={`action.delete-event`} id="tooltip-download-latest" img={`/icons/delete.png`} />
            <ImgToolTip className="icon-hover" intl={intl} placement="left" tooltiptext={`action.delete-event`} id="tooltip-download-latest-hover" img={`/icons/delete-hover.png`} />
            <ImgToolTip className="icon-focus" intl={intl} placement="left" tooltiptext={`action.delete-event`} id="tooltip-download-latest-focus" img={`/icons/delete-focus.png`} />
          </Button>
          <span>{location}</span>
        </div>
      </div>
      <div className="video-presentations">
        <Link to={link}>
          <Button>
            <PreIcon />
            {intl.formatMessage({id: 'common.presentations.text'})}
          </Button>
        </Link>
        <a href={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${slug}`} target="_blank" rel="noopener noreferrer">
          <Button>
            <VidIcon />
            {intl.formatMessage({id: 'common.videos.text'})}
          </Button>
        </a>
      </div>
      <Link className="d-flex w-10" to={`/event/edit/${id}`}>
        <Button className="btn-return">
          {intl.formatMessage({ id: "edit-new" })}
        </Button>
      </Link>
    </div>
  );
};

export default injectIntl(AddedEvent);
